import { IHeaderParams } from "ag-grid-community";
import React from "react";

import { IgTypography } from "@intelligems/ig-theme";
import Stack from "@mui/material/Stack";
import { HeaderParams } from "@src/components/MainApp/SharedProductPicker/types";
import { ProductPickerSelectedProduct } from "@src/store/slices/productPicker/types";

export const ProductListHeader = (
  props: IHeaderParams<ProductPickerSelectedProduct>
) => {
  const headerParams = props.column.getColDef().headerComponentParams as
    | HeaderParams
    | undefined;

  return (
    <Stack
      direction={"column"}
      justifyContent="center"
      sx={{ height: "100%", width: "100%", ...headerParams?.sx }}
    >
      <IgTypography>{props.displayName}</IgTypography>
    </Stack>
  );
};
